import React from "react";
import Home from "../components/Home/Home.jsx";
import Slider from "../components/Swiper/MainSwiper/Slider.jsx";
import Photo1 from "../components/photos/photo1/Photo1.jsx";
import Photo2 from "../components/photos/photo2/Photo2.jsx";
import Photo3 from "../components/photos/photo3/Photo3.jsx";
const array = [Photo1, Photo2, Photo3];

const Homepage = () => {
  return (
    <div className="content">
      <Slider render={array} />
      <Home />
    </div>
  );
};

export default Homepage;
